__turbopack_context__.v({
  "countLabel": "tabs-module-scss-module__fAHXra__countLabel",
  "isTabActive": "tabs-module-scss-module__fAHXra__isTabActive",
  "isTabDisabled": "tabs-module-scss-module__fAHXra__isTabDisabled",
  "tab": "tabs-module-scss-module__fAHXra__tab",
  "tabCountLabel": "tabs-module-scss-module__fAHXra__tabCountLabel",
  "tableTabs": "tabs-module-scss-module__fAHXra__tableTabs",
  "tabsFooter": "tabs-module-scss-module__fAHXra__tabsFooter",
});
